var _g, _circle, _line, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDesignItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3658_10722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1671 32.584C20.1837 32.584 21.1588 32.9879 21.8776 33.7067C22.5965 34.4256 23.0004 35.4007 23.0004 36.4173V38.334H46.0004V36.4173C46.0004 35.4007 46.4043 34.4256 47.1232 33.7067C47.8421 32.9879 48.8171 32.584 49.8337 32.584C50.8504 32.584 51.8254 32.9879 52.5443 33.7067C53.2632 34.4256 53.6671 35.4007 53.6671 36.4173V46.0007C53.6671 46.509 53.4651 46.9965 53.1057 47.3559C52.7463 47.7154 52.2587 47.9173 51.7504 47.9173H17.2504C16.7421 47.9173 16.2546 47.7154 15.8951 47.3559C15.5357 46.9965 15.3337 46.509 15.3337 46.0007V36.4173C15.3337 35.4007 15.7376 34.4256 16.4565 33.7067C17.1754 32.9879 18.1504 32.584 19.1671 32.584V32.584Z",
    stroke: "#5F6787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1672 32.584V26.834C19.1672 25.309 19.773 23.8465 20.8514 22.7681C21.9297 21.6898 23.3922 21.084 24.9172 21.084H44.0839C45.6089 21.084 47.0714 21.6898 48.1498 22.7681C49.2281 23.8465 49.8339 25.309 49.8339 26.834V32.584",
    stroke: "#5F6787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5005 21.084V38.334",
    stroke: "#5F6787",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 33.5,
    stroke: "#5F6787",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 59.5594,
    y1: 11.5303,
    x2: 11.53,
    y2: 59.5598,
    stroke: "#5F6787",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3658_10722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(11.5005 11.5005)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDesignItems);
export default __webpack_public_path__ + "static/media/noDesignItems.45cda7548318c770124c451d652036ef.svg";
export { ForwardRef as ReactComponent };